import React from 'react';
const H = 24;
const W = 38;
const cardBase = {
  rx: 4,
  width: W,
  height: H
};
/** Visa — white card with blue VISA */
function Visa() {
  return <svg viewBox={`0 0 ${W} ${H}`} height={H} aria-label="Visa" data-id="element-147">
      <rect {...cardBase} fill="#ffffff" data-id="element-148" />
      <text x={W / 2} y="17" textAnchor="middle" fontFamily="Arial Black, Arial, sans-serif" fontWeight="900" fontStyle="italic" fontSize="11" fill="#1A1F71" letterSpacing="0" data-id="element-149">
        VISA
      </text>
    </svg>;
}
/** Mastercard — white card with two overlapping circles */
function Mastercard() {
  return <svg viewBox={`0 0 ${W} ${H}`} height={H} aria-label="Mastercard" data-id="element-150">
      <rect {...cardBase} fill="#ffffff" data-id="element-151" />
      <circle cx={W / 2 - 4} cy={H / 2} r="6.5" fill="#EB001B" data-id="element-152" />
      <circle cx={W / 2 + 4} cy={H / 2} r="6.5" fill="#F79E1B" fillOpacity="0.95" data-id="element-153" />
      <path d={`M${W / 2} ${H / 2 - 4.5} a6.5 6.5 0 0 1 0 9 6.5 6.5 0 0 1 0 -9z`} fill="#FF5F00" data-id="element-154" />
    </svg>;
}
/** American Express — blue card with white AMEX */
function Amex() {
  return <svg viewBox={`0 0 ${W} ${H}`} height={H} aria-label="American Express" data-id="element-155">
      <rect {...cardBase} fill="#2E77BB" data-id="element-156" />
      <text x={W / 2} y="16" textAnchor="middle" fontFamily="Arial Black, Arial, sans-serif" fontWeight="900" fontSize="8" fill="#ffffff" letterSpacing="0.5" data-id="element-157">
        AMEX
      </text>
    </svg>;
}
/** PayPal — white card with two-tone PayPal */
function PayPal() {
  return <svg viewBox={`0 0 ${W} ${H}`} height={H} aria-label="PayPal" data-id="element-158">
      <rect {...cardBase} fill="#ffffff" data-id="element-159" />
      <text x={W / 2} y="16" textAnchor="middle" fontFamily="Arial Black, Arial, sans-serif" fontWeight="900" fontStyle="italic" fontSize="9" letterSpacing="-0.3" data-id="element-160">
        <tspan fill="#003087" data-id="element-161">Pay</tspan>
        <tspan fill="#009CDE" data-id="element-162">Pal</tspan>
      </text>
    </svg>;
}
/** Apple Pay — black card with white Apple + Pay */
function ApplePay() {
  return <svg viewBox={`0 0 ${W} ${H}`} height={H} aria-label="Apple Pay" data-id="element-163">
      <rect {...cardBase} fill="#000000" data-id="element-164" />
      {/* Apple silhouette */}
      <path d="M11.4 9.5c-.5.6-1.2 1-1.9.9-.1-.7.3-1.5.7-1.9.5-.6 1.3-1 1.9-1 .1.7-.2 1.5-.7 2zm.6 1.1c-1-.1-1.8.6-2.3.6-.5 0-1.2-.6-2-.6-1 0-1.9.6-2.4 1.5-1 1.8-.3 4.4.8 5.9.5.7 1.1 1.5 1.8 1.5.7 0 1-.5 1.8-.5s1.1.5 1.8.5c.8 0 1.3-.7 1.8-1.4.5-.8.8-1.6.8-1.6s-1.5-.6-1.5-2.3c0-1.4 1.2-2.1 1.2-2.1-.7-1-1.7-1.1-2-1.1z" fill="#ffffff" transform="translate(-1 -2)" data-id="element-165" />
      <text x="18" y="16" fontFamily="-apple-system, system-ui, Helvetica, sans-serif" fontWeight="600" fontSize="8" fill="#ffffff" data-id="element-166">
        Pay
      </text>
    </svg>;
}
/** Google Pay — white card with multi-color G Pay */
function GooglePay() {
  return <svg viewBox={`0 0 ${W} ${H}`} height={H} aria-label="Google Pay" data-id="element-167">
      <rect {...cardBase} fill="#ffffff" data-id="element-168" />
      {/* Mini Google G */}
      <g transform="translate(5 5)" data-id="element-169">
        <circle cx="7" cy="7" r="6.5" fill="none" data-id="element-170" />
        <path d="M7 .5a6.5 6.5 0 0 1 4.6 1.9l-1.9 1.9A3.9 3.9 0 0 0 7 3.1 3.9 3.9 0 0 0 3.1 7H.5A6.5 6.5 0 0 1 7 .5z" fill="#EA4335" data-id="element-171" />
        <path d="M.5 7a6.5 6.5 0 0 0 1.9 4.6l1.9-1.9A3.9 3.9 0 0 1 3.1 7z" fill="#FBBC04" data-id="element-172" />
        <path d="M2.4 11.6A6.5 6.5 0 0 0 7 13.5v-2.6A3.9 3.9 0 0 1 4.3 9.7z" fill="#34A853" data-id="element-173" />
        <path d="M7 13.5a6.5 6.5 0 0 0 6.5-6.5h-2.6A3.9 3.9 0 0 1 7 10.9z" fill="#4285F4" data-id="element-174" />
        <rect x="6.5" y="5.5" width="5.5" height="2" fill="#4285F4" data-id="element-175" />
      </g>
      <text x="21" y="16" fontFamily="Arial, Helvetica, sans-serif" fontWeight="600" fontSize="8" fill="#5F6368" data-id="element-176">
        Pay
      </text>
    </svg>;
}
const Brands = [Visa, Mastercard, Amex, PayPal, ApplePay, GooglePay];
export function PaymentLogos({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex flex-wrap items-center justify-center gap-4 mt-4 ${className}`} data-id="element-177">
      {Brands.map((Brand, i) => <div key={i} className="flex items-center opacity-90 hover:opacity-100 transition-opacity duration-300" data-id="element-178">
          <Brand data-id="element-179" />
        </div>)}
    </div>;
}